<template>
  <div class="gis-info-box">
    <div class="title">
      {{ cityName }}
      <!--<div class="city">-->
      <!--</div>-->

      <span class="time">
        <!--2022上半年-->
      </span>
    </div>
    <div class="gis-content">
      <div class="gis-content-item" v-for="(item, i) in infoConArr" :key="i">
        <span class="name">{{ item && item.name ? item.name : '-' }}：</span>
        <span :class="item.click ? 'click' : ''" @click="handleClick(item)"
          ><span class="num">{{ item && item.val ? item.val : '-' }}</span> {{ item && item.unit }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getCityData } from '../../api/getMapData';

export default {
  name: 'GisInfoBox',
  props: {
    // 地图类型 - 1 全国，2 广东
    type: {
      type: Number,
      default: 1,
    },
    cityName: {
      type: String,
      default: '',
    },
    dataObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      basicInfoConArr: [
        {
          name: '地区生产总值',
          unit: '',
          val: '',
        },
        {
          name: '一般公共预算收入',
          unit: '',
          val: '',
        },
        {
          name: '常住人口',
          unit: '',
          val: '',
        },
        {
          name: '户籍人口',
          unit: '',
          val: '',
        },
        {
          name: '全国民营企业500强',
          unit: '家',
          click: true,
          val: '',
        },
      ],
    };
  },
  computed: {
    infoConArr() {
      let arr = this.type === 1 ? this.basicInfoConArr.slice(4, 5) : this.basicInfoConArr;
      if (this.type === 1) {
        let data = this.dataObj[this.cityName];
        data && data.length
          ? (arr = arr.map((item) => {
              let conData = data.filter((child) => child.quotaName === item.name)[0];
              item.val = conData?.quantity;
              item.unit = conData?.unit;
              return {
                ...conData,
                ...item,
              };
            }))
          : '';
      }
      return arr;
    },
  },
  methods: {
    handleClick(item) {
      if (!item.val) {
        this.$message.warning('暂无数据！');
        return;
      }
      this.$bus.$emit('showEn500Dialog', {
        type: this.type,
        name: this.cityName,
        year: item.year,
      });
    },
    getData() {
      if (!this.cityName && this.type !== 1) return;
      // let arrName = `basicInfoConArr${this.type}`
      this.cityName = this.cityName.replace('市', '');
      this.$api.screen
        .getMapQuota({
          name: this.cityName,
        })
        .then((res) => {
          let { data } = res.data;
          this.basicInfoConArr = this.basicInfoConArr.map((item) => {
            let conData = data.filter((child) => child.quotaName === item.name)[0];
            item.val = conData?.quantity;
            item.unit = conData?.unit;
            return {
              ...conData,
              ...item,
            };
          });
        });
      // getCityData().then(res => {
      //   let data = res.filter(item => this.cityName.includes(item['地市']))[0];
      //   this.basicInfoConArr = this.basicInfoConArr.map(item => {
      //     item.val = data[item.name];
      //     item.unit = data[`${item.name}单位`];
      //     return item;
      //   });
      // })
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
.gis-info-box {
  width: 332px;
  position: relative;
  background: rgba(20, 26, 38, 0.9);
  box-shadow: 0 0 4px 1px rgba(170, 240, 250, 0.19);
  border-radius: 3px;
  color: #fff;
  font-size: 14px;

  &::before {
    content: '';
    border: 14px solid transparent;
    border-top-color: rgba(20, 26, 38, 0.9);
    position: absolute;
    /*transform: rotate(45deg);*/
    left: calc(50% - 14px);
    border-radius: 3px;
    bottom: -26px;
  }

  .title {
    width: 332px;
    height: 41px;
    background: linear-gradient(90deg, rgba(71, 166, 249, 0.5), rgba(71, 166, 249, 0));
    border-radius: 3px 3px 0 0;
    position: relative;
    .flex-center();
    font-size: 18px;

    &::before {
      content: '';
      width: 22px;
      height: 44px;
      background: url('~img/home/chart-box-title-icon.png') no-repeat;
      background-size: 100% 100%;
      margin-right: 13px;
    }

    .time {
      font-size: 14px;
      color: #fff;
      text-shadow: 0 4px 4px rgba(30, 40, 60, 0.6);
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .gis-content {
    padding: 10px 20px;

    .gis-content-item {
      line-height: 40px;
      .flex-center();
      justify-content: space-between;

      > span {
        word-break: break-all;
        color: #fff;
        text-shadow: 0 4px 4px rgba(30, 40, 60, 0.6);

        &:last-child {
          font-style: italic;
        }

        &.click .num {
          color: #aafdfe;
        }

        .num {
          font-size: 16px;
          font-weight: 900;
          font-family: Geometr706 BlkCn BT;
          /*text-shadow: 0px 4px 4px rgba(30,40,60,0.6000);*/
        }
      }
    }
  }
}
</style>
